const STRINGS = {
  submitFeedback: "Submit Feedback",
  visitAppStore: "Visit App Store",
  downloadOtherApps: "Download Other Apps",
  about: "About",
  feedback: "Submit VB Parkfinder App Feedback",
  moreInformation: "More Information",
  version: "Version",
  location: "Location",
  hours: "Hours",
  phone: "Phone",
  amenities: "Amenities",
  notes: "Notes",
  seamlessLink: "https://vbforms.seamlessdocs.com/f/591aee3f813a504e82d289d7894aac37",
  appleAppstoreLink: "https://apps.apple.com/us/app/vb-parkfinder/id978036707",
  googlePlaystoreLink: "https://play.google.com/store/apps/details?id=com.vbgov.vbparkfinder",
  vbconnectOtherAppsLink: "https://vbconnect.vbgov.com/apps",
  parksRentalLink: "https://parks.virginiabeach.gov/outdoors/rentals-reservations/park-shelter-reservations",
  parksAdoptionLink:
    "https://vbgov.maps.arcgis.com/apps/instant/basic/index.html?appid=e72e24d264d1422ca0f68a6c70ee71f4",
  couldNotOpenLink: "Could not open link",
  metaListDescription: "Settings page for VBGo app",
  contactParks: "Contact Parks and Recreation",
  parksNumber: "757-385-1100",
  parksEmail: "fun@vbgov.com",
  errorUnableToLoadParks: "Unable to load parks data. Please refresh the page.",
  errorUnableToLoadParkDetails: "Unable to load park's details. Please refresh the page.",
  errorUnableToLoadAmenities: "Unable to load Filter page. Please refresh the page.",
  noParksDataFound: "No parks data found.",
  noAmenitiesDataFound: "No amenities data found.",
  mapCouldNotMeOpened: "An error occurred while opening the map.",
};

export default STRINGS;
